import { useDispatch, useSelector } from 'react-redux'

import { Recipe, RecipeCoreId } from '@library/menu-service'

import { setTutorialViewed } from 'actions/tutorial'
import { useCollection, useCurrentCollectionId } from 'hooks/menu-collections'
import { useAuth } from 'routes/Menu/domains/auth'

export type RecipeSet = {
  recipe: Recipe
  originalId: RecipeCoreId
  reference: string
}

export function useCustomisationEducation(recipeSets?: RecipeSet[]) {
  const tutorialKey = 'customisation_education'

  const dispatch = useDispatch()
  const collectionId = useCurrentCollectionId()
  const collection = useCollection(collectionId)
  const { isAuthenticated } = useAuth()

  const hasViewed = useSelector((state: any) => {
    const viewed = state.tutorial?.get('viewed').get(tutorialKey)

    return viewed
  })

  if (!isAuthenticated || hasViewed) {
    return {
      recipeIdForEducation: null,
    }
  }

  const foundSet = recipeSets?.find((set) => {
    const mainRecipe = set.recipe

    const baseRecipe =
      collection?.recipes.find((recipe) => recipe.id === mainRecipe.id) ||
      collection?.recipes.find((recipe) =>
        recipe.options?.some((option) => option.id === mainRecipe.id),
      )

    const optionsType = baseRecipe?.optionsType || 'none'

    return optionsType === 'ingredients'
  })

  const recipeId = foundSet ? foundSet.recipe.id : null

  const closeEducation = () => {
    dispatch(setTutorialViewed(tutorialKey, 1))
  }

  return {
    recipeIdForEducation: recipeId,
    closeEducation,
  }
}
